module.exports = __webpack_public_path__ + "static/predefined_template_1-666350dd324eb57899752040d0342ff2.png";